import { userAgent } from './'

/**
 * Helper function to determine if the current browser is IE 11.
 *
 * @since 0.1.2
 *
 * @returns {boolean} Whether or not this is IE 11.
 */
export function isIe11() {
	return !!window.MSInputMethodContext && !!document.documentMode
}

/**
 * Helper function to determine if this is Internet Explorer or not.
 * This works for IE 10-
 *
 * @since 0.1.2
 *
 * @returns {boolean} Whether or not the browser is IE 10 or below.
 */
export function isIe() {
	return -1 !== userAgent().indexOf('MSIE') || isIe11()
}
